import React from "react";
import moment from "moment";
import EditLogo from "../../Assets/editLogo.png";
import "./OperatorCard.css";

const OperatorCard = ({
  data,
  index,
  dataUser,
  isEdit,
  setIsEdit,
  isOn,
  handleFormChange,
}) => {
  const downtime = data.downtime ? data.downtime : 0;
  const lastCounterAkhir = data.lastCounterAkhir ? data.lastCounterAkhir : 0;
  const dataCounterAwal = data.counterAwal ? data.counterAwal : 0;
  const dataCounterAkhir = data.counterAkhir ? data.counterAkhir : 0;

  const formula =
    (28800 - downtime * 60) / (dataCounterAkhir - dataCounterAwal);

  const dataSisaShiftSebelumnya = data.sisaShiftSebelumnya
    ? data.sisaShiftSebelumnya
    : 0;
  const dataLastSisaShiftSebelumnya =
    data.lastSisaShiftSebelumnya && dataUser.tim === 1
      ? data.lastSisaShiftSebelumnya
      : 0;
  const checkSisaShift =
    data.jumlahBarang + dataLastSisaShiftSebelumnya ===
    data.aktualBarang + dataSisaShiftSebelumnya;

  // ===== Reject rate & Pencapaian (sama dengan rumus di DashboardPPIC) =====
  const dataTargetProduk = data.targetProduk ? data.targetProduk : 0;
  const dataAktualCavity = data.aktualCavity ? data.aktualCavity : 0;
  const formulaTargetProduksi = dataTargetProduk * dataAktualCavity;

  const totalProduksi =
    Number(data.jumlahNG || 0) + Number(data.jumlahBarang || 0);
  const rejectRate =
    totalProduksi > 0
      ? ((Number(data.jumlahNG || 0) / totalProduksi) * 100).toFixed(1)
      : "0.0";

  const pencapaianNum =
    formulaTargetProduksi > 0
      ? (Number(data.jumlahBarang || 0) / formulaTargetProduksi) * 100
      : null;
  const pencapaian =
    pencapaianNum === null ? "-" : `${pencapaianNum.toFixed(0)}%`;
  const pencapaianLow = pencapaianNum !== null && pencapaianNum < 80;
  // =========================================================================

  const canEdit = isEdit && data.operator === dataUser.name;

  const renderNum = (name, suffix = "", color) =>
    canEdit ? (
      <input
        type="number"
        className="input_dashboard_operator"
        name={name}
        value={data[name]}
        onChange={(e) => handleFormChange(index, e)}
        onWheel={(e) => e.target.blur()}
      />
    ) : (
      <p className="op_value" style={color ? { color } : {}}>
        {data[name]}
        {suffix}
      </p>
    );

  const sisaWarning =
    dataLastSisaShiftSebelumnya > 0 && !(checkSisaShift && dataUser.tim === 1);

  return (
    <div
      className={
        lastCounterAkhir !== dataCounterAwal
          ? "wrapper_card_approval_laporan op_card op_card_warning"
          : "wrapper_card_approval_laporan op_card"
      }
    >
      <div className="op_form_row">
        <span>
          {dataUser.tim === 1 ? "Form-PROD-A28-R2" : "Form-PROD-A28-R8"}
        </span>
        <span>{moment(data.dateSubmit).format("HH:mm:ss")}</span>
      </div>

      <div className="op_header">
        <div>
          <p className="tittle-machine-dashboard op_machine">
            Mesin&nbsp;{data.mesin}
          </p>
          <p className="op_date">{moment(data.date).format("DD MMM YYYY")}</p>
        </div>
        <div className="op_header_right">
          <p className="tittle-customer-dashboard op_customer">
            {data.customer}
          </p>
          {data.isKepala === false ? (
            <img
              className="width_edit_logo op_edit_logo"
              onClick={() => setIsEdit(true)}
              src={EditLogo}
              alt="edit_logo"
            />
          ) : (
            ""
          )}
        </div>
      </div>

      <p className="op_operator">{data.operator}</p>
      <p className="op_mold">{data.moldType}</p>
      <div className="op_color_row">
        <span className="op_color">{data.color}</span>
        <span className="op_shift">Shift&nbsp;{data.shift}</span>
      </div>

      {/* ===== KPI: Reject rate & Pencapaian ===== */}
      <div className="op_kpi_row">
        <div className="op_kpi op_kpi_reject">
          <span className="op_kpi_label">Reject Rate</span>
          <span className="op_kpi_value">{rejectRate}%</span>
        </div>
        {!isOn ? (
          <div
            className={
              pencapaianLow ? "op_kpi op_kpi_low" : "op_kpi op_kpi_good"
            }
          >
            <span className="op_kpi_label">Pencapaian</span>
            <span className="op_kpi_value">{pencapaian}</span>
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="op_grid">
        <div>
          <p className="op_label">Isi Per Kemasan</p>
          <p className="op_value">{data.isiPerKemasan}&nbsp;Pcs</p>
        </div>
        <div>
          <p className="op_label">Aktual Cavity</p>
          <p className="op_value">{data.aktualCavity}</p>
        </div>

        <div>
          <p className="op_label">Counter Akhir</p>
          {renderNum("counterAkhir")}
        </div>
        <div>
          <p className="op_label">Counter Awal</p>
          {renderNum("counterAwal")}
        </div>

        <div>
          <p className="op_label">Selisih Counter</p>
          <p className="op_value">
            {data.counterAkhir - data.counterAwal}&nbsp;Pcs
          </p>
        </div>
        <div>
          <p className={sisaWarning ? "op_label op_text_red" : "op_label"}>
            {dataUser.tim === 2
              ? "Sisa Shift Sebelumnya"
              : `Receh Shift ${data.shift}`}
          </p>
          <p className={sisaWarning ? "op_value op_text_red" : "op_value"}>
            {data.sisaShiftSebelumnya ? data.sisaShiftSebelumnya : 0}
            &nbsp;Pcs
          </p>
        </div>

        <div>
          <p className="op_label">Jumlah "NG"</p>
          <p className="op_value">{data.jumlahNG}&nbsp;Pcs</p>
        </div>
        <div>
          <p className="op_label op_text_green">Barang OK</p>
          {renderNum("jumlahBarang", "\u00A0Pcs", "lightseagreen")}
        </div>

        {!isOn ? (
          <>
            <div>
              <p className="op_label">Down Time</p>
              <p className="op_value">{downtime}&nbsp;Menit</p>
            </div>
            <div>
              <p className="op_label">Cycle Time</p>
              <p className="op_value">
                {formula === Infinity ? 0 : formula.toFixed(1)}
                &nbsp;Detik
              </p>
            </div>
          </>
        ) : (
          ""
        )}

        {dataUser.tim === 2 ? (
          <div className="op_span_2">
            <p className="op_label">Produk OK + SISA</p>
            <p className="op_value">
              {Number(data.jumlahBarang) + Number(data.sisaShiftSebelumnya)
                ? Number(data.jumlahBarang) + Number(data.sisaShiftSebelumnya)
                : 0}
            </p>
          </div>
        ) : (
          ""
        )}

        <div>
          <p className="op_label">Aktual Barang</p>
          {renderNum("aktualBarang", "\u00A0Pcs")}
        </div>
        {dataUser.tim === 2 ? (
          <div>
            <p className="op_label">Selisih Barang</p>
            <p className="op_value">
              {data.aktualBarang
                ? Number(data.aktualBarang) -
                  Number(data.jumlahBarang) -
                  Number(data.sisaShiftSebelumnya)
                : 0}
              &nbsp;Pcs
            </p>
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="op_section">
        <div className="op_ng_head">
          <span>Perincian "NG"</span>
          <span>Jumlah</span>
        </div>
        {data.perincianNG &&
          data.perincianNG.map((perincian) => (
            <div className="op_ng_row" key={perincian.id}>
              <span className="size-keterangan-dashboard">{perincian.id}</span>
              <span className="size-keterangan-dashboard">
                {perincian.totalNG}&nbsp;Pcs
              </span>
            </div>
          ))}
      </div>

      <div className="op_section">
        {data.keterangan !== "" || dataUser.tim === 2 ? (
          <div>
            <p className="op_label">Keterangan</p>
            <div
              dangerouslySetInnerHTML={{
                __html: data.keterangan.replace(/\n/g, "<br/>"),
              }}
              className="size-keterangan-dashboard"
            />
          </div>
        ) : (
          <div className="op_table_wrap">
            <table className="op_table">
              <thead>
                <tr>
                  <th>Jam</th>
                  <th>Keterangan</th>
                </tr>
              </thead>
              <tbody>
                {data.dataKeterangan.map((ele, i) => (
                  <tr key={i}>
                    <td className="op_td_jam">{ele.jam}</td>
                    <td className="op_td_ket">{ele.keterangan}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default OperatorCard;
